import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { stepButtonsVisibility } from "../utils";

const FIRST_STEP_SLUG = "/accusation";

let slugs = [];
let oldPathIndex = -1;
let values = {};

const useNavigationSync = ({ handleSubmit, wizard, form }) => {
  const history = useHistory();
  const location = useLocation();

  const {
    slug,
    machineAnswers,
    isLoading,
    stepKey,
    questions,
    goBack,
  } = wizard;

  const { reset: formReset } = form;

  useEffect(() => {
    if (slug) {
      const hasSlugChangedByMachine = history.location.pathname !== slug;

      if (hasSlugChangedByMachine) {
        history.push(slug);
        const idx = slugs.indexOf(slug);
        const howMany = idx > -1 ? slugs.length - idx : 0;
        slugs.splice(idx, howMany);
      }

      if (!slugs.includes(slug)) {
        if (slug === FIRST_STEP_SLUG || slugs[0] === FIRST_STEP_SLUG) {
          slugs.push(slug);
        }
      }
    }
  }, [slug, history]);

  useEffect(() => {
    const pathIndex = slugs.indexOf(location.pathname);

    let hasPathChangedByBrowser = true;
    if (isLoading) hasPathChangedByBrowser = false;
    else if (pathIndex === -1) hasPathChangedByBrowser = false;
    else if (pathIndex >= slugs.length) hasPathChangedByBrowser = false;
    else if (location.pathname === "/") hasPathChangedByBrowser = false;
    else if (slug === location.pathname) hasPathChangedByBrowser = false;

    if (!hasPathChangedByBrowser) {
      oldPathIndex = pathIndex;
      return false;
    }

    if (pathIndex > oldPathIndex) {
      handleSubmit({ [stepKey]: values[stepKey] });
    } else if (pathIndex < oldPathIndex) {
      const { shouldDisplayButtons, shouldDisplayBack } = stepButtonsVisibility(
        {
          stepKey,
          questions,
        }
      );

      if (shouldDisplayButtons && shouldDisplayBack) {
        goBack();
      }
    }
  }, [location, slug, isLoading, goBack, handleSubmit, stepKey, questions]);

  useEffect(() => {
    values = { ...values, ...machineAnswers };

    formReset({
      [stepKey]: values[stepKey],
      ...machineAnswers,
    });
  }, [stepKey, machineAnswers, formReset]);
};

export default useNavigationSync;
